import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { OrderHeadInvoiceFormGroup } from '../../order-head-edit/order-head-edit.component';
import { DeliveryTermItem } from '@app/services/logistic.service';
import { FactoringItem, InvoiceMethodsItem, PaymentTypeItem, PriceListItem, TaxItem, ValutaItem } from '@app/services/economy.service';
import { CollectionItem } from '@app/services/collection.service';
import { SpecialDiscount2Item } from '@app/services/discount-group.service';

@Component({
    selector: 'tt-order-head-price-form',
    templateUrl: './order-head-price-form.component.html',
    styleUrls: ['./order-head-price-form.component.css'],
})
export class OrderHeadPriceFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadInvoiceFormGroup>;

    @Input()
    public deliveryTerms: DeliveryTermItem[] = [];

    @Input()
    public payments: PaymentTypeItem[] = [];

    @Input()
    public factorings: FactoringItem[] = [];

    @Input()
    public pricelists: PriceListItem[] = [];

    @Input()
    public taxes: TaxItem[] = [];

    @Input()
    public invoiceMethods: InvoiceMethodsItem[] = [];

    @Input()
    public valutas: ValutaItem[] = [];

    @Input()
    public discount2s: SpecialDiscount2Item[] = [];

    @Input()
    public collections: CollectionItem[] = [];
}
